/**
 * Shared 3D door leaf / handle style enums used by the Property Panel and meshes.
 * Missing metadata falls back to today's flush leaf + lever handle (or bar for glass sliding).
 */

export const DOOR_STYLES = ["flush", "paneled", "glazed"] as const;
export type DoorStyle = (typeof DOOR_STYLES)[number];

export const DOOR_HANDLE_STYLES = ["lever", "knob", "bar", "none"] as const;
export type DoorHandleStyle = (typeof DOOR_HANDLE_STYLES)[number];

export const DEFAULT_DOOR_STYLE: DoorStyle = "flush";
export const DEFAULT_DOOR_HANDLE_STYLE: DoorHandleStyle = "lever";

const DOOR_STYLE_SET = new Set<string>(DOOR_STYLES);
const DOOR_HANDLE_STYLE_SET = new Set<string>(DOOR_HANDLE_STYLES);

/**
 * Resolves leaf appearance from `symbol.threeD`. Unknown / missing → flush.
 */
export function resolveDoorStyle(
  doorStyle: string | undefined | null,
): DoorStyle {
  if (doorStyle && DOOR_STYLE_SET.has(doorStyle)) {
    return doorStyle as DoorStyle;
  }
  return DEFAULT_DOOR_STYLE;
}

/**
 * Resolves handle / knob style from `symbol.threeD`.
 * Glass sliding doors historically used a pull bar — prefer that when unset.
 */
export function resolveDoorHandleStyle(
  doorHandleStyle: string | undefined | null,
  options?: { preferBarDefault?: boolean },
): DoorHandleStyle {
  if (doorHandleStyle && DOOR_HANDLE_STYLE_SET.has(doorHandleStyle)) {
    return doorHandleStyle as DoorHandleStyle;
  }
  return options?.preferBarDefault ? "bar" : DEFAULT_DOOR_HANDLE_STYLE;
}
